import React, { useMemo } from 'react'
import { SelectOption } from '@Components/Selectors/Select'
import CellDropdown from '@Components/ViewWork/Table/ValidationCells/CellDropdown'
import CellInput from '@Components/ViewWork/Table/ValidationCells/CellInput'
import { OptionModel } from '@Entities/lib'
import { TableRowData } from '@Components/ViewWork/Table'
import { formatName } from '@App/helpers/format-name'
import { WriterModel } from '@Entities/work/writer-model'

interface UseWriterTableRowsParams {
    writers: WriterModel[]
    roleOptions: SelectOption[]
    onRoleChange: (index: number, writer: WriterModel, newValue: OptionModel) => void
}

export const useWriterTableRows = ({ writers, roleOptions, onRoleChange }: UseWriterTableRowsParams) => {
    const getRole = (roleCode: number | null): string => {
        if (!roleCode) {
            return ''
        }
        const writerRole = roleOptions.find((role: SelectOption) => +role.id === roleCode)
        return writerRole?.label ?? ''
    }

    const headerRow = {
        row: [{ text: 'Writer Name' }, { text: 'Writer IPI' }, { text: 'Writer Role' }],
        removableCells: true,
    }

    const rows = useMemo(
        () =>
            writers.map((writerModel, index): TableRowData => ({
                removeCellIdentifier: writerModel.ipId ?? '',
                removable: true,
                cells: [
                    <CellInput
                        defaultValue={formatName(writerModel.firstName, writerModel.lastName)}
                        readOnly
                        name={`rows[${index}].writerName`}
                        key={`${writerModel.ipId}.writerName`}
                        type="text"
                    />,
                    <CellInput
                        name={`rows[${index}].writerIPI`}
                        key={`${writerModel.ipId}.writerIPI`}
                        defaultValue={writerModel.ipiNumber ?? ''}
                        readOnly
                        type="text"
                    />,
                    <CellDropdown
                        name={`rows[${index}].writerRole`}
                        key={`${writerModel.ipId}.writerRole`}
                        value={getRole(writerModel.roleCode)}
                        onSelectedValueChanged={(newValue) => onRoleChange(index, writerModel, newValue)}
                    />,
                ],
            })),
        [writers]
    )

    return [{ headerRow, rows }]
}
